module.exports = {
    authHeader: (vue) => {
        hObj = {};
        let userToken = vue.$cookie.get('access_token');
        if (userToken) {
            hObj['Authorization'] = 'Bearer ' + userToken ;
        }
        hObj['cur'] = vue.$store.state.selectedCurrency;
        hObj['content-language'] = vue.$store.state.currentLanguage;
        hObj['domain'] = JSON.stringify(vue.$store.state.domain);

        return hObj;
    }
} 


// WEBPACK FOOTER //
// src/util/header.js